/* eslint-disable no-unused-vars */
import { useDispatch, useSelector } from 'react-redux'
import { updateFormType } from '@store/slice/mainSlice'
import { cityFormObject } from '@form/cityFormFields'
import { missionBillingFormObject } from '@form/missionBillingFormFields'
import { permissionSubjectFormObject } from '@form/permissionSubjectFormFields'
import { mairieFormObject } from '@form/mairieFormFields'
import { documentFormObject } from '@form/documentFormFields'
import { districtFormObject } from '@form/districtFormFields'
import { freeCodeFormObject } from '@form/freeCodeFormFields'
import { userRegisterFormObject } from "@form/userRegisterFormFields"
import { missionContactFormObject } from "@form/missionContactFormFields"
import { missionSubjectFormObject } from "@form/missionSubjectFormFields"
import { billingTypeFormObject } from "@form/billingTypeFormFields"
import { pageFormObject } from "@form/pageFormFields"
import { nuisanceFormObject } from "@form/nuisanceFormFields"
import { mailTemplateFormObject } from "@form/mailTemplateFormFields"
import { feedBackFormObject } from "@form/feedBackFormFields"
import { loadCallsFormFields, loadCallsFormObject } from '@form/loadCallsFormFields'

const useDynamicForm = () => {
  const { mission } = useSelector(state => state.main)
  const dispatch = useDispatch()

  const formsObject = {
    district: districtFormObject,
    freeCode: freeCodeFormObject,
    missionContact: missionContactFormObject,
    page: pageFormObject,
    mailTemplate: mailTemplateFormObject,
    userRegister: userRegisterFormObject,
    document: documentFormObject,
    missionSubject: missionSubjectFormObject,
    missionBilling: missionBillingFormObject,
    nuisance: nuisanceFormObject,
    feedBack: feedBackFormObject
  }

  const getFormObject = (formType, initObject = null, missionId = null) => {
    initObject = null !== initObject ? { ...initObject } : { ...formsObject[formType] }
    if (missionId) {
      initObject.missionId = missionId
    }
    return initObject
  }

  const createModalFormAction = (formType, dynamicStore = null, initObject = null) => {
    let action
    switch (formType) {
      case 'userRole':
        action = { dynamicFormType: formType, dynamicFormObject: getFormObject(formType, initObject, null), dynamicStore }
        break
      case 'permissionSubject':
        action = { dynamicFormType: formType, dynamicFormObject: { ...permissionSubjectFormObject }, dynamicStore }
        break
      case 'city':
        action = { dynamicFormType: formType, dynamicFormObject: { ...cityFormObject }, dynamicStore }
        break
      case 'billingType':
        action = { dynamicFormType: formType, dynamicFormObject: { ...billingTypeFormObject }, dynamicStore }
        break
      case 'mairie':
        action = { dynamicFormType: formType, dynamicFormObject: { ...mairieFormObject }, dynamicStore }
        break
      case 'missionBilling':
        action = { dynamicFormType: formType, dynamicFormObject: getFormObject(formType, initObject, mission.id), dynamicStore }
        break
      case 'document':
      case 'district':
      case 'mailTemplate':
      case 'page':
      case 'missionContact':
      case 'userRegister':
      case 'loadCalls':
      case 'missionSubject':
      case 'freeCode':
      case 'nuisance':
      case 'feedBack':
        action = { dynamicFormType: formType, dynamicFormObject: getFormObject(formType, initObject, mission.id), dynamicStore }
        break
    }
    dispatch(updateFormType(action))
  }


  return createModalFormAction
}

export default useDynamicForm